import { render, staticRenderFns } from "./PagamentoComprometimentos.vue?vue&type=template&id=d4f4ea66"
import script from "./PagamentoComprometimentos.vue?vue&type=script&lang=js"
export * from "./PagamentoComprometimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports